import {BaseContainerModel} from '../../base-container.model';
import {bl_inv_txn_line_fact_RowClass} from '../../../dbschema';

export class InventoryTransactionLineFactContainerModel extends BaseContainerModel {
  bl_inv_txn_line_fact: bl_inv_txn_line_fact_RowClass = new bl_inv_txn_line_fact_RowClass();
}
